import UTILIZADOR from "@/store/schemas/utilizador"
import INSTITUICAO from "@/store/schemas/instituicao"
import BRIGADA from "@/store/schemas/brigada"
import COLHEITA from "@/store/schemas/colheita"
import DADIVA from "@/store/schemas/dadiva"
import GALARDAO from "@/store/schemas/galardao"
import GALARDAO_PEDIDO from "@/store/schemas/galardao_pedido"
import ASSOCIADO from "@/store/schemas/associado"
import UTILIZADOR_COLHEITA from "@/store/schemas/utilizador_colheita"
import DONATIVO from "@/store/schemas/donativo"

// -- ACTIONS
const _ACTIONS = {
  edit: {
    icon: "edit",
    color: "light-green darken-1",
    action: "edit"
  },
  delete: {
    icon: "delete",
    color: "red lighten-1",
    action: "delete"
  },
  colheita: {
    icon: "favorite",
    color: "amber lighten-1",
    action: "colheita"
  },
  delete_colheita: {
    icon: "delete",
    color: "red lighten-1",
    action: "delete_colheita"
  },
  comprovativo_donativo: {
    icon: "mdi-download",
    color: "cyan darken-1",
    action: "comprovativo_donativo"
  }
}

// -- SCHEMAS
const _MODELS = {
  UTILIZADOR: {
    _ACTIONS: [_ACTIONS.edit, _ACTIONS.delete],
    _FIELDS: UTILIZADOR._FIELDS,
    _HEADERS: UTILIZADOR._HEADERS
  },
  INSTITUICAO: {
    _ACTIONS: [_ACTIONS.edit, _ACTIONS.delete],
    _FIELDS: INSTITUICAO._FIELDS,
    _HEADERS: INSTITUICAO._HEADERS
  },
  BRIGADA: {
    _ACTIONS: [_ACTIONS.edit, _ACTIONS.delete],
    _FIELDS: BRIGADA._FIELDS,
    _HEADERS: BRIGADA._HEADERS
  },
  COLHEITA: {
    _ACTIONS: [_ACTIONS.colheita, _ACTIONS.edit, _ACTIONS.delete],
    _FIELDS: COLHEITA._FIELDS,
    _HEADERS: COLHEITA._HEADERS
  },
  DADIVA: {
    _ACTIONS: [_ACTIONS.edit, _ACTIONS.delete],
    _FIELDS: DADIVA._FIELDS,
    _HEADERS: DADIVA._HEADERS
  },
  GALARDAO: {
    _ACTIONS: [_ACTIONS.edit],
    _FIELDS: GALARDAO._FIELDS,
    _HEADERS: GALARDAO._HEADERS
  },
  GALARDAO_PEDIDO: {
    _ACTIONS: [_ACTIONS.edit, _ACTIONS.delete],
    _FIELDS: GALARDAO_PEDIDO._FIELDS,
    _HEADERS: GALARDAO_PEDIDO._HEADERS
  },
  ASSOCIADO: {
    _ACTIONS: [_ACTIONS.edit, _ACTIONS.delete],
    _FIELDS: ASSOCIADO._FIELDS,
    _HEADERS: ASSOCIADO._HEADERS
  },
  UTILIZADOR_COLHEITA: {
    _ACTIONS: [_ACTIONS.delete_colheita],
    _FIELDS: UTILIZADOR_COLHEITA._FIELDS,
    _HEADERS: UTILIZADOR_COLHEITA._HEADERS
  },
  DONATIVO: {
    _ACTIONS: [_ACTIONS.comprovativo_donativo, _ACTIONS.edit, _ACTIONS.delete],
    _FIELDS: DONATIVO._FIELDS,
    _HEADERS: DONATIVO._HEADERS
  }
}

export { _MODELS }
